@if (commander && playerInfo) {
	<div class="sst_PlayerWelcomeContainer container-fluid">
		@switch (commander?.info?.callingApplication) {
			@case (CallingApplication.Recording) {
				<ng-container *ngVar="event$ | async as event">
					@if (event) {
						<div class="eventContainer" [@fadeInOnEnter]>
							<div class="eventDate">
								{{ event.start | date: (T.DATE_FORMAT_LONG_DAY | translate) : "" : translate.currentLang }}
							</div>
							<div class="eventName">
								{{ event.name }}
							</div>
							@if (event?.description) {
								<div class="eventDescription">
									{{ event?.description }}
								</div>
							}
							<div class="infoContainer">
								{{ T.WELCOME_SIMULATION_WILL_START_SOON_INFO_TEXT | translate }}
							</div>
						</div>
					}
				</ng-container>
				<div class="playerInfo">
					<div class="playerNameText">
						{{ T.PLAYER_NAME | translate }}
					</div>
					<div class="playerNameValue">
						{{ playerInfo?.name }}
					</div>
				</div>
			}
			@default {
				<div class="eventContainer" [@fadeInOnEnter]>
					<div class="eventDate">
						{{ today | date: (T.DATE_FORMAT_LONG_DAY | translate) : "" : translate.currentLang }}
					</div>
					<div class="eventName">
						{{ CallingApplication[commander?.info?.callingApplication] }}
					</div>
					<ng-container *ngVar="commander?.info?.userId | getUserById | async as user">
						@if (user && !user.roleIds?.includes("Guest")) {
							<div class="eventDescription">
								{{
									"CALLING_APPLICATION_" + CallingApplication[commander?.info?.callingApplication] + "_DESCRIPTION"
										| translate
											: {
													username: user?.firstname + " " + user.lastname,
											  }
								}}
							</div>
						}
						@if (!user || user.roleIds?.includes("Guest")) {
							<div class="eventDescription">
								{{
									"CALLING_APPLICATION_" +
										CallingApplication[commander?.info?.callingApplication] +
										"_DESCRIPTION_WITHOUT_USER" | translate
								}}
							</div>
						}
					</ng-container>
					<div class="infoContainer">
						{{
							"WELCOME_" + CallingApplication[commander?.info?.callingApplication] + "_WILL_START_SOON_INFO_TEXT" | translate
						}}
					</div>
				</div>
				<div class="playerInfo">
					<div class="playerNameText">
						{{ T.PLAYER_NAME | translate }}
					</div>
					<div class="playerNameValue">
						{{ playerInfo?.name }}
					</div>
				</div>
			}
		}
	</div>
}
